import React from "react";
import { SEO, DynamicScript } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class StylistMatchingQuizPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.brassfields.com/stylist-matching-quiz/"}
        />
        <Grid
          className={"custom-page-match-with-a-stylist custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"kfdmbamfkgpdejod"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"ammnolfmjpbdeakb"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__2546686f-1a42-4a61-ae72-0aa5a79aeaa0"}
                >
                  <div>
                    <div id={"glammatic-form-Y53T4ddJa9ydTR2XM3RA"} />
                    <DynamicScript
                      type={"application/javascript"}
                      delay={300}
                      body={
                        "GlammaticForm.init({container: '#glammatic-form-Y53T4ddJa9ydTR2XM3RA',username: 'brassfields-salon-spa',slug: 'stylist-matching'});"
                      }
                    />
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 36054 }) {
      title
      seoTitle
      description
    }
  }
`;
